import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
export var Tableau = {
  methods: {
    syncTableauWorkbook: function syncTableauWorkbook() {
      var workbook = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var params = {
        domain: window.userInfo.domain
      };
      if (workbook) {
        params['workbook'] = workbook;
      }
      TableauDashboardService.syncTableauWorkbook(params).catch(function (e) {
        console.info(e);
      });
    },
    syncTableauDatasource: function syncTableauDatasource() {
      var datasource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var params = {
        domain: window.userInfo.domain
      };
      if (datasource) {
        params['datasource'] = datasource;
      }
      TableauDatasourceService.syncTableauDatasource(params).catch(function (e) {
        console.info(e);
      });
    }
  }
};